var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScaleIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1784 11.1784C12.5768 9.78003 14.5609 7.79586 15.8218 6.53503L17.0776 7.79086C17.5318 8.24503 18.3084 7.92503 18.3118 7.28336L18.3334 2.7167C18.3359 2.13586 17.8643 1.6642 17.2834 1.6667L12.7168 1.68836C12.0743 1.6917 11.7551 2.46836 12.2093 2.92253L13.4651 4.17836C12.2043 5.4392 10.2201 7.42336 8.82178 8.8217L11.1784 11.1784Z",
    fill: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82151 8.82166C7.42318 10.22 5.43901 12.2042 4.17818 13.465L2.92235 12.2092C2.46818 11.755 1.69151 12.075 1.68818 12.7167L1.66651 17.2833C1.66401 17.8642 2.13568 18.3358 2.71651 18.3333L7.28318 18.3117C7.92568 18.3083 8.24485 17.5317 7.79068 17.0775L6.53485 15.8217C7.79568 14.5608 9.77985 12.5767 11.1782 11.1783L8.82151 8.82166Z",
    fill: "#6C6C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleIc);
export default __webpack_public_path__ + "static/media/scaleIc.caeeb4513850a84e9e87d09e4ce7f48e.svg";
export { ForwardRef as ReactComponent };